export default "__VITE_ASSET__78dde22f__"